// /components/CampaignInfo.jsx
import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const CampaignInfo = ({ handleCamapaignId }) => {
  const authData = useSelector((state) => state.auth.authData);
  const campaignData = useSelector(
    (state) => state.auth?.authData?.user?.campaigns
  );
  const [filter, setFilter] = useState("all");
  const [search, setSearch] = useState("");
  const [creatorData, setCreatorData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (authData?.user?._id && campaignData) {
      const foundCreator = (Array.isArray(campaignData) ? campaignData : [])
        .flatMap((campaign) => campaign.creators || [])
        .find((creator) => creator._id === authData.user._id);

      if (foundCreator) {
        setCreatorData(foundCreator);
      } else {
        console.log("Creator Not Found!");
      }
    }
  }, [authData?.user._id, campaignData]);

  const filteredCampaigns = useMemo(() => {
    return (campaignData || []).filter((campaign) => {
      const matchFilter =
        filter === "all" || campaign.status === filter;
      const matchSearch = campaign.campaignName
        .toLowerCase()
        .includes(search.toLowerCase());
      return matchFilter && matchSearch;
    });
  }, [campaignData, filter, search]);

  const handleDetails = (id) => {
    handleCamapaignId(id);
    navigate(`/campaignDashboard`);
  };

  return (
    <div className="p-2" style={{ fontFamily: 'Gilroy-Medium' }}>
         <h1 >Campaigns</h1>
      <div className="flex flex-col sm:flex-row justify-between items-center mb-4 gap-3">
        <input
          type="text"
          placeholder="Search campaigns..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="border border-gray-300 px-3 py-2 rounded-md text-sm w-full sm:w-64"
        />
        <select
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="border border-gray-300 px-3 py-2 rounded-md text-sm w-full sm:w-48"
        >
          <option value="all">All Campaigns</option>
          <option value="running">Running</option>
          <option value="completed">Completed</option>
        </select>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
       {filteredCampaigns.map((campaign) => (
          <div
            key={campaign._id}
            className="bg-white border p-4 rounded-xl border-2 overflow-hidden"
          >
            <div className="  flex flex-row items-center">
              <div className="mr-2">
                <img
                  src={campaign.campaignLogo || "https://placehold.co/400"}
                  alt="Campaign Logo"
                  className="w-full h-10 rounded  object-contain "
                />
              </div>
              <div>
                <h4 className="font-semibold text-md truncate">
                  {campaign.campaignName}
                </h4>
              </div>
              <div className="ml-auto">
                {" "}
                <span
                  className={`text-xs font-medium px-2 py-1 rounded-full ${
                    campaign.status === "running"
                      ? "bg-blue-100 text-blue-600"
                      : campaign.status === "pending"
                      ? "bg-yellow-100 text-yellow-700"
                      : "bg-gray-200 text-gray-700"
                  }`}
                >
                  {campaign.status.charAt(0).toUpperCase() +
                    campaign.status.slice(1)}
                </span>
              </div>
            </div>

            <div className=" space-y-2">
              <div className="text-sm mt-1 text-gray-700 space-y-1">
                <div className="flex justify-between">
                  <strong>Payout:</strong>
                  <span>${campaign.payout}</span>
                </div>
                <div className="flex justify-between">
                  <strong>Deadline:</strong>
                  <span>
                    {new Date(campaign.deadline).toLocaleDateString()}
                  </span>
                </div>
                <div className="flex justify-between">
                  <strong>Content Type:</strong>
                  <span>{campaign.platform === "Instagram"? "Reel, Instagram" : "Shorts, Youtube"}</span>
                </div>
              </div>
              <button
                className="mt-2 w-full border border-gray-300 text-blue-500 py-1.5 rounded-md text-sm hover:bg-gray-50"
                onClick={() => handleDetails(campaign._id)}
              >
                View Details
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CampaignInfo;